// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zhin","inner":"Footer_inner__1yd8M"};